module.exports = __webpack_public_path__ + "img/JDBKLALA.b6a1f561.jpg";